const pageNameKey = "alarmProfileCard";

export const alarmProfileCardEn = {
  [pageNameKey]: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    warning: "Are you sure you want to delete this profile?",
    warningIconAltText: "Warning triangle",
  },
};

export const alarmProfileCardPtBr = {
  [pageNameKey]: {
    save: "Salvar",
    cancel: "Cancelar",
    delete: "Excluir",
    warning: "Tem certeza de que deseja excluir este perfil?",
    warningIconAltText: "Triângulo de advertência",
  },
};

export const alarmProfileCardDe = {
  [pageNameKey]: {
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    warning: "Sind Sie sicher, dass Sie dieses Profil löschen möchten?",
    warningIconAltText: "Warnung Dreieck",
  },
};

export const alarmProfileCardZhHans = {
  [pageNameKey]: {
    save: "保存",
    cancel: "取消",
    delete: "删除",
    warning: "您确定要删除此配置文件吗？",
    warningIconAltText: "警告三角形",
  },
};

export const alarmProfileCardIt = {
  [pageNameKey]: {
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    warning: "Sei sicuro di voler eliminare questo profilo?",
    warningIconAltText: "Attenzione!",
  },
};

export const alarmProfileCardEs = {
  [pageNameKey]: {
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    warning: "¿Seguro que quieres eliminar este perfil?",
    warningIconAltText: "Triángulo de advertencia",
  },
};

export const alarmProfileCardNl = {
  [pageNameKey]: {
    cancel: "Annuleren",
    delete: "Verwijderen",
    save: "Opslaan",
    warning: "Weet u zeker dat u dit profiel wilt verwijderen?",
    warningIconAltText: "Gevarendriehoek",
  },
};

export const alarmProfileCardTr = {
  [pageNameKey]: {
    cancel: "İptal etmek",
    delete: "Silmek",
    save: "Kaydetmek",
    warning: "Bu profili silmek istediğinizden emin misiniz?",
    warningIconAltText: "Uyarı üçgeni",
  },
};
